import { collection, query, where, orderBy, limit, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';

// Firestore no tiene búsqueda de texto libre, y cargar el catálogo entero de
// `productos` (~22.700 documentos reales de StelOrder) para filtrar en el
// cliente es justo lo que hay que evitar — no solo por volumen, también
// porque el stock real de StelOrder no está bien cuadrado, así que filtrar
// "solo los que tienen stock" tampoco es un criterio fiable para reducir el
// universo. La alternativa que no depende de la calidad del dato: buscar
// bajo demanda, combinando un rango por prefijo en `name` (en dos variantes,
// ver abajo), un rango por prefijo en `reference` en mayúsculas (las
// referencias/SKU suelen ir así) y una coincidencia exacta en `barcode` (los
// EAN se escanean, no se escriben a mano). No sustituye un buscador de texto
// completo, pero evita traer miles de documentos para encontrar uno.
//
// `name` en StelOrder NO sigue un criterio único: el material real de
// almacén suele venir en MAYÚSCULAS TOTALES ("JUNTA PLETINA D.75", "TAPA
// SUPERIOR"), mientras que algunas líneas de mano de obra vienen en
// mayúscula solo inicial ("Mantenimiento preventivo ACS"). Antes solo se
// probaba la mayúscula inicial — como "JUNTA..." ordena ANTES que "Junta..."
// en Firestore, ese rango nunca encontraba la inmensa mayoría del material
// real (Rafa: "introducir material" en una orden daba siempre sin
// resultados, 2026-10-15). Se prueban las dos variantes y se combinan.
export async function buscarProductosPorTexto(termino, { max = 8 } = {}) {
  const t = (termino || '').trim();
  if (t.length < 2) return [];

  const capitalizado = t[0].toUpperCase() + t.slice(1);
  const todoMayus = t.toUpperCase();
  const refMayus = t.toUpperCase();
  const col = collection(db, 'productos');

  const safeQuery = (q) => getDocs(q).catch(() => ({ docs: [] }));
  const nombreRange = (desde) => safeQuery(query(col, orderBy('name'),
    where('name', '>=', desde), where('name', '<', desde + ''), limit(max)));

  const [porNombre, porNombreMayus, porReferencia, porBarcode] = await Promise.all([
    nombreRange(capitalizado),
    capitalizado === todoMayus ? Promise.resolve({ docs: [] }) : nombreRange(todoMayus),
    safeQuery(query(col, orderBy('reference'),
      where('reference', '>=', refMayus), where('reference', '<', refMayus + ''), limit(max))),
    safeQuery(query(col, where('barcode', '==', t), limit(1))),
  ]);

  const vistos = new Map();
  [...porNombre.docs, ...porReferencia.docs, ...porBarcode.docs].forEach(d => {
    if (!vistos.has(d.id)) vistos.set(d.id, { id: d.id, ...d.data() });
  });
  return Array.from(vistos.values()).filter(p => p.inactive !== true).slice(0, max);
}
